import { BankIdData } from "@/lib/types/checkout-steps";
import checkmark from "@/assets/check-mark.svg";
import { capitalizeEachWord } from "@/lib/utils/strings";

export function BankIdSummary({ data }: { data: BankIdData }) {
  const textClassName = "text-sm";
  return (
    <div className="space-y-1">
      <div className="flex items-center">
        <p className={textClassName}>{capitalizeEachWord(data.name)}</p>
        <img className="ml-1 h-3 w-3" src={checkmark} alt="BankID Checkmark" />
      </div>
      <p className={textClassName}>{data.email}</p>
      <p className={textClassName}>{data.phone}</p>
    </div>
  );
}
